import React, { useEffect, useState } from "react";
import { Bell, Inbox, Trash2 } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";
import api from "../lib/api";

export default function Alerts() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const data = await api.listAlerts();
      setAlerts(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const clearAll = async () => {
    if (!window.confirm("Alle Alerts löschen?")) return;
    await api.clearAlerts();
    toast.success("Alle Alerts gelöscht.");
    load();
  };

  return (
    <div className="p-6 md:p-8 max-w-5xl mx-auto" data-testid="alerts-page">
      <div className="flex items-start justify-between gap-4 mb-2">
        <div>
          <div className="font-display text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-2">
            Benachrichtigungen
          </div>
          <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight leading-none">
            Alerts
          </h1>
        </div>
        {alerts.length > 0 && (
          <Button
            variant="outline"
            onClick={clearAll}
            className="border-zinc-700 bg-transparent hover:bg-zinc-800 text-xs"
            data-testid="btn-clear-alerts"
          >
            <Trash2 size={12} className="mr-1" /> Alle löschen
          </Button>
        )}
      </div>
      <p className="text-zinc-400 text-sm mb-8">Historie aller ausgelösten Zonen-Alerts.</p>

      {loading ? (
        <div className="text-zinc-500 text-sm">Lade...</div>
      ) : alerts.length === 0 ? (
        <div className="border border-dashed border-zinc-800 p-12 text-center">
          <Inbox size={48} className="mx-auto text-zinc-700 mb-4" strokeWidth={1} />
          <h3 className="font-display font-bold text-xl mb-2">Noch keine Alerts</h3>
          <p className="text-zinc-500 text-sm">
            Sobald eine Zone erreicht wird, erscheinen hier automatische Benachrichtigungen.
          </p>
        </div>
      ) : (
        <div className="border border-zinc-800 bg-zinc-950 divide-y divide-zinc-800">
          {alerts.map(a => {
            const isInfo = a.kind === "info";
            return (
              <div key={a.id} className="p-4 flex items-start gap-3" data-testid={`alert-${a.id}`}>
                <Bell size={16} className={`mt-1 shrink-0 ${isInfo ? "text-zinc-500" : "text-amber-500"}`} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-display font-bold text-sm">{a.asset_name}</span>
                    <span className="text-[10px] uppercase tracking-widest text-zinc-500 font-display">
                      {isInfo ? "Info" : a.zone_type.replace("_", " ")}
                    </span>
                    {a.sent_via === "telegram" && (
                      <span className="px-1.5 py-0.5 bg-emerald-500/20 text-emerald-400 text-[9px] font-display font-bold uppercase rounded-sm">
                        TELEGRAM
                      </span>
                    )}
                  </div>
                  <div className="text-xs text-zinc-400 mt-1">{a.message}</div>
                  <div className="flex items-center gap-3 text-[10px] text-zinc-600 font-mono-num mt-2">
                    {!isInfo && <span>Zone: {a.zone_price_min}–{a.zone_price_max}</span>}
                    {a.triggered_price && <span>· @ {a.triggered_price}</span>}
                    <span>· {new Date(a.triggered_at).toLocaleString("de-DE")}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
